import './LandIndustryDetailPage.css'
import './LandProductListPage.css'
import 'antd/dist/reset.css'
import React from 'react'
import LandBottomLayout from '../common/LandBottomLayout'
import { getIndustryByIid } from '../../products/ProductProvider'

export default class LandIndustryDetailPage extends React.Component {
  constructor(props) {
    super(props)
    const [iid, industry] = this.getIidAndIndustry(this.props.location.search)
    this.state = {
      iid: iid,
      industry: industry,
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps = async (nextProps) => {
    if (this.props.location.search !== nextProps.location.search) {
      const [iid, industry] = this.getIidAndIndustry(nextProps.location.search)
      this.setState({
        iid: iid,
        industry: industry,
      })
      return true
    }
  }

  render() {
    return (
      <div>
        <div className="LandIndustryDetail">
          <div className="LandIndustryDetailHeader">
            <img
              className="LandIndustryDetailHeaderImage"
              src={this.state.industry.picture}
            />
            <div className="LandIndustryDetailHeaderTextWrapper">
              <div className="LandIndustryDetailHeaderTextContainer">
                <div className="LandIndustryDetailName">
                  {this.state.industry.title}
                </div>
                <div className="LandIndustryDetailIntroduction">
                  {this.state.industry.subtitle}
                </div>
              </div>
            </div>
          </div>

          <div className="LandIndustryDetailDocument">
            {this.state.industry.document.map((paragraph) => {
              return this.getParagraph(paragraph)
            })}
          </div>
        </div>

        <LandBottomLayout {...this.props} />
      </div>
    )
  }

  getParagraph = (paragraph) => {
    return (
      <div className={`LandIndustryDetailParagraph_${paragraph.style}`}>
        {paragraph.content}
      </div>
    )
  }

  getIidAndIndustry = (search) => {
    var i = search.indexOf('iid=')
    const iid = parseInt(search.substring(i + 4, search.length))
    const industry = getIndustryByIid(iid)
    return [iid, industry]
  }
}
